import React from "react";
import { Radio, Button } from "antd";

const SelectionStep = ({
  selectedOption,
  setSelectedOption,
  onCancel,
  onConfirm,
}) => (
  <>
    <h4>Descargar Informe o Mediciones</h4>
    <p>¿Qué tipo de información desea descargar?</p>
    <Radio.Group
      onChange={(e) => setSelectedOption(e.target.value)}
      value={selectedOption}
      className="radio-group"
    >
      <Radio value="simpleReport">Informe Simplificado</Radio>
      <Radio value="detailedReport">Informe Detallado</Radio>
      <Radio value="csv">Mediciones CSV</Radio>
      <Radio value="excel">Mediciones Excel</Radio>
    </Radio.Group>

    <div className="footer-buttons">
      <Button type="default" className="cancel-button" onClick={onCancel}>
        Cancelar
      </Button>
      <Button type="default" className="download-button" onClick={onConfirm}>
        Descargar
      </Button>
    </div>
  </>
);

export default SelectionStep;
